import React, { useRef, useState } from 'react'
import { BookingService } from '../../services/Booking/BookingService';
import { previsualizar, procesar, crearEnMaestro, GRUPO_POR_CAMPO, previsualizarAtaBnp, procesarAtaBnp } from '../../services/Booking/CargaBookingService';
import { logBooking, cancelarBooking, reactivarBooking } from '../../services/Logistica/DoleService';
import { FileUpload } from 'primereact/fileupload';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';

import { InputNumber } from 'primereact/inputnumber';
import { TabView, TabPanel } from 'primereact/tabview';
import { Toast } from 'primereact/toast';
import { InputText } from 'primereact/inputtext';
import { BlockUI } from 'primereact/blockui';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Dialog } from 'primereact/dialog';

const Booking = () => {
    const bookingService = new BookingService();
    const dropdown = useRef(null);

    const [anio, setAnio] = useState();
    const [semana, setSemana] = useState("");
    const [mes, setMes] = useState(null);
    const [dia, setDia] = useState(null);
    const [listaBooking, setListaBooking] = useState([]);
    const fileUploadRef = useRef(null);
    const [estado, setEstado] = useState("");
    const [blockedDataTable, setBlockedDataTable] = useState(false);
    const [booking, setBooking] = useState("");

    // ---- Previsualizacion de la carga (RF-B10) ----
    const [preview, setPreview] = useState(null);
    const [previewVisible, setPreviewVisible] = useState(false);
    const [previewArchivo, setPreviewArchivo] = useState(null);

    // ---- Import de ATA BNP por archivo (BOOKING + ATA_BNP) ----
    const ataUploadRef = useRef(null);
    const [ataPreview, setAtaPreview] = useState(null);
    const [ataPreviewVisible, setAtaPreviewVisible] = useState(false);
    const [ataArchivo, setAtaArchivo] = useState(null);

    // ---- Visor del log unificado (RF-LOG) ----
    const [logVisible, setLogVisible] = useState(false);
    const [logFilas, setLogFilas] = useState([]);

    // Cancelar / Reactivar booking (booking sin viaje que se cancela)
    const [accionBk, setAccionBk] = useState(null);   // { bookingId, tipo: 'cancelar' | 'reactivar' }
    const [motivoBk, setMotivoBk] = useState('');
    const [accionBkVisible, setAccionBkVisible] = useState(false);

    const abrirAccionBk = (bookingId, tipo) => { setAccionBk({ bookingId, tipo }); setMotivoBk(''); setAccionBkVisible(true); };
    const confirmarAccionBk = async () => {
        if (!motivoBk || !motivoBk.trim()) {
            toast.current.show({ severity: 'warn', summary: 'Motivo', detail: 'Ingrese un motivo', life: 3000 });
            return;
        }
        try {
            if (accionBk.tipo === 'cancelar') await cancelarBooking(accionBk.bookingId, motivoBk.trim());
            else await reactivarBooking(accionBk.bookingId, motivoBk.trim());
            toast.current.show({ severity: 'success', summary: 'OK', detail: accionBk.tipo === 'cancelar' ? 'Booking cancelado' : 'Booking reactivado', life: 3000 });
            setAccionBkVisible(false);
            buscar();
        } catch (e) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: e.message || 'No se pudo completar', life: 4000 });
        }
    };

    const toast = useRef(null);

    const meses = [
        { name: 'Enero', value: "01" },
        { name: 'Febrero', value: "02" },
        { name: 'Marzo', value: "03" },
        { name: 'Abril', value: "04" },
        { name: 'Mayo', value: "05" },
        { name: 'Junio', value: "06" },
        { name: 'Julio', value: "07" },
        { name: 'Agosto', value: "08" },
        { name: 'Septiembre', value: "09" },
        { name: 'Octubre', value: "10" },
        { name: 'Noviembre', value: "11" },
        { name: 'Diciembre', value: "12" }
    ];

    const dias = [
        { name: 'Lunes', value: "1" },
        { name: 'Martes', value: "2" },
        { name: 'Miercoles', value: "3" },
        { name: 'Jueves', value: "4" },
        { name: 'Viernes', value: "5" },
        { name: 'Sabado', value: "6" },
        { name: 'Domingo', value: "0" },
        { name: 'Todos', value: "-1" }
    ];

    const estados = [
        { name: 'Activo', value: "Activo" },
        { name: 'Incompleto', value: "Incompleto" },
        { name: 'Utilizado', value: "Utilizado" },
        { name: 'Anulado', value: "Anulado" }
    ];




    const buscar = () => {
        setBlockedDataTable(true);
        const bookingService = new BookingService();

        if (estado === 'Incompleto') {
            bookingService.getBookingPorEstado(estado).then(data => {

                setListaBooking(data);

                setBlockedDataTable(false);

            }).catch(e => {
                setBlockedDataTable(false);
            })
        } else if (!booking) {
            bookingService.getBookingPorFiltroLogistico(anio, mes, semana, dia, estado).then(data => {

                setListaBooking(data);
                console.log(data);
                setBlockedDataTable(false);

            }).catch(e => {
                setBlockedDataTable(false);
            })
        } else {
            bookingService.getBookingPorCodigo(booking).then(data => {

                setListaBooking(data);
                console.log(data);
                setBlockedDataTable(false);

            }).catch(e => {
                setBlockedDataTable(false);
            })
        }

        console.log(anio + " : " + mes + " : " + semana + " : " + dia);
    }

    const guardar = () => {
        setBlockedDataTable(true);
        bookingService.guardar(listaBooking).then(data => {
            setBlockedDataTable(false);
            buscar();
        }).catch(e => {
            setBlockedDataTable(false);
        });
    }

    const onChangeSemana = (value) => {
        if (value == undefined) {
            setSemana("-1")
        } else {
            setSemana(value)
        }
    }



    // =================================================================
    // Carga con PREVISUALIZACION y VALIDACION (RF-B10 / RF-B11)
    // El flujo nuevo no guarda nada hasta que el usuario revisa la grilla:
    //   previsualizar -> resolver faltantes -> procesar (solo lo valido)
    // =================================================================
    const onPreviewUpload = async (e) => {
        const file = e.files && e.files[0];
        if (!file) return;
        setBlockedDataTable(true);
        try {
            const data = await previsualizar(file);
            if (data.error) {
                showFail(data.error);
            } else {
                setPreviewArchivo(file);
                setPreview(data);
                setPreviewVisible(true);
            }
        } catch (err) {
            showFail('No se pudo previsualizar: ' + (err?.message || ''));
        } finally {
            if (fileUploadRef.current) fileUploadRef.current.clear();
            setBlockedDataTable(false);
        }
    };

    /** Aplica las filas validas; las que tienen novedad quedan pendientes. */
    const onProcesarPreview = async () => {
        if (!previewArchivo) return;
        setBlockedDataTable(true);
        try {
            const data = await procesar(previewArchivo);
            showSuccess(`Procesado: ${data.filasAplicadas} de ${data.filasTotal} filas`
                + (data.filasNovedad > 0 ? ` · ${data.filasNovedad} con novedad quedaron pendientes` : ''));
            setPreviewVisible(false);
            setPreview(null);
            setPreviewArchivo(null);
        } catch (err) {
            showFail('No se pudo procesar: ' + (err?.message || ''));
        } finally {
            setBlockedDataTable(false);
        }
    };

    /** Crea en el maestro el valor que falta y vuelve a validar el archivo. */
    const onCrearFaltante = async (novedad) => {
        const grupo = GRUPO_POR_CAMPO[novedad.campo];
        if (!grupo) {
            showFail('Ese faltante no se resuelve desde un maestro: ' + novedad.motivo);
            return;
        }
        // En BARCO-VIAJE se crea la SIGLA (ej. DPC609 -> DPC)
        const valor = novedad.campo === 'BARCOVIAJE'
            ? String(novedad.valor || '').replace(/[0-9].*$/, '').trim()
            : String(novedad.valor || '').trim();
        if (!valor) {
            showFail('No se pudo determinar el valor a crear');
            return;
        }
        setBlockedDataTable(true);
        try {
            await crearEnMaestro(grupo, valor, novedad.campo === 'BARCOVIAJE' ? valor : null);
            showSuccess(`"${valor}" creado en el maestro`);
            // revalidar con el maestro ya actualizado
            const data = await previsualizar(previewArchivo);
            setPreview(data);
        } catch (err) {
            showFail('No se pudo crear: ' + (err?.message || ''));
        } finally {
            setBlockedDataTable(false);
        }
    };

    // =================================================================
    // Import de ATA BNP por archivo (BOOKING + ATA_BNP)
    // Flujo: previsualizar (dry-run) -> revisar detalle -> procesar (upsert).
    // Re-cargable: subir de nuevo ajusta el valor por cualquier motivo.
    // =================================================================
    const onAtaPreviewUpload = async (e) => {
        const file = e.files && e.files[0];
        if (!file) return;
        setBlockedDataTable(true);
        try {
            const data = await previsualizarAtaBnp(file);
            if (data.error) {
                showFail(data.error);
            } else {
                setAtaArchivo(file);
                setAtaPreview(data);
                setAtaPreviewVisible(true);
            }
        } catch (err) {
            showFail('No se pudo previsualizar: ' + (err?.message || ''));
        } finally {
            if (ataUploadRef.current) ataUploadRef.current.clear();
            setBlockedDataTable(false);
        }
    };

    const onProcesarAta = async () => {
        if (!ataArchivo) return;
        setBlockedDataTable(true);
        try {
            const data = await procesarAtaBnp(ataArchivo);
            showSuccess(`ATA BNP: ${data.filasOk} de ${data.filasTotal} bookings actualizados`
                + (data.filasError > 0 ? ` · ${data.filasError} con error` : ''));
            setAtaPreviewVisible(false);
            setAtaPreview(null);
            setAtaArchivo(null);
        } catch (err) {
            showFail('No se pudo procesar: ' + (err?.message || ''));
        } finally {
            setBlockedDataTable(false);
        }
    };

    /** RF-LOG: historial del booking y el de sus viajes, todo junto. */
    const verLogBooking = async (fila) => {
        setBlockedDataTable(true);
        try {
            setLogFilas(await logBooking(fila.bookingId) || []);
            setLogVisible(true);
        } catch (err) {
            showFail('No se pudo cargar el log: ' + (err?.message || ''));
        } finally {
            setBlockedDataTable(false);
        }
    };

    // Etiquetas legibles de cada columna del archivo (clave normalizada -> label).
    const CAMPO_LABEL = {
        BOOKING: 'Booking', BARCOVIAJE: 'Barco-Viaje', TIPO: 'Tipo', PRIORIDAD: 'Prioridad',
        ANO: 'Año', ANIO: 'Año', MES: 'Mes', SEMANA: 'Semana', FECHA: 'Fecha', DIASEMANA: 'Día semana',
        FINCACODIGO: 'Finca código', FINCACODIGOFINAL: 'Finca destino', DISTANCIAKM: 'Distancia (km)',
        MISMODIA: 'Mismo día', ATABNP: 'ATA BNP'
    };
    // Orden en que se muestran las columnas del preview (las que existan en el archivo).
    const ORDEN_CAMPOS = ['BOOKING', 'BARCOVIAJE', 'TIPO', 'PRIORIDAD', 'ANO', 'ANIO', 'MES', 'SEMANA',
        'FECHA', 'DIASEMANA', 'FINCACODIGO', 'FINCACODIGOFINAL', 'DISTANCIAKM', 'MISMODIA', 'ATABNP'];

    const columnasPreview = (preview) => {
        const cols = (preview && preview.columnas) || [];
        return [...ORDEN_CAMPOS.filter((k) => cols.includes(k)), ...cols.filter((k) => !ORDEN_CAMPOS.includes(k))];
    };

    /** Celda de estado por fila: "Válida" o el detalle ESTRUCTURADO de las novedades. */
    const estadoFilaTemplate = (fila) => {
        const nov = fila.novedades || [];
        if (nov.length === 0) {
            return (
                <span style={{ background: '#DCFCE7', color: '#166534', padding: '2px 8px', borderRadius: 6, fontWeight: 600, fontSize: '0.8rem' }}>
                    ✓ Válida
                </span>
            );
        }
        return (
            <div className="flex flex-column gap-1">
                {nov.map((n, i) => (
                    <div key={i} className="flex align-items-center gap-2" style={{ fontSize: '0.82rem' }}>
                        <span style={{ background: '#FEE2E2', color: '#991B1B', padding: '1px 7px', borderRadius: 5, fontWeight: 600, whiteSpace: 'nowrap' }}>
                            {CAMPO_LABEL[n.campo] || n.campo}
                        </span>
                        <span style={{ color: '#374151' }}>
                            {n.motivo}{n.valor ? <> — <i>“{n.valor}”</i></> : null}
                        </span>
                        {GRUPO_POR_CAMPO[n.campo] && (
                            <Button label="Crear" icon="pi pi-plus" className="p-button-sm p-button-text"
                                onClick={() => onCrearFaltante(n)} />
                        )}
                    </div>
                ))}
            </div>
        );
    };

    // Flujo ANTERIOR (sube y procesa directo). Se conserva para no romper el uso
    // actual; la pantalla ya ofrece el flujo con preview.
    const onBasicUploadAuto = async (e) => {
        setBlockedDataTable(true);
        try {
            for (const file of e.files) {
                try {
                    const data = await bookingService.subirArchivo(file);
                    if (data.codigo.includes('ERR')) {
                        showFail(data.mensaje + ' - ' + data.mensajeSistema);
                    } else {
                        showSuccess("Archivo Cargado");
                    }
                } catch (err) {
                    showFail('Error al subir el archivo: ' + (err?.message || ''));
                }
            }
        } finally {
            if (fileUploadRef.current) fileUploadRef.current.clear();
            setBlockedDataTable(false);
        }
    }

    const showFail = (message) => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: message, life: 3000 });
    }

    const showSuccess = (message) => {
        toast.current.show({ severity: 'success', summary: 'Success Message', detail: message, life: 3000 });
    }



    const onBasicUpload = (message) => {
        toast.current.show({ severity: 'info', summary: 'Success', detail: message, sticky: true });
    }

    const cellEditor = (options) => {
        if (options.field === 'estado') return estadoEditor(options);
        else return textEditor(options);
    };

    const textEditor = (options) => {
        return <InputText type="text" value={options.value} onChange={(e) => options.editorCallback(e.target.value)} />;
    };

    const estadoEditor = (options) => {

        return (
            <Dropdown
                ref={dropdown}
                value={options.rowData['estado']}
                options={estados}
                onChange={(e) => onEstadoChange(options, e)}
                placeholder="Seleccionar Estado"
                optionLabel="name"
                itemTemplate={(option) => {
                    return <span className='product-badge'>{option.name}</span>
                }}
            />
        );
    };


    const onEstadoChange = async (options, e) => {
        let _listaBooking = [...listaBooking]
        options.editorCallback(e.value);
        options.rowData['estado'] = e.value;
        _listaBooking[options.rowIndex] = options.rowData;
        setListaBooking(_listaBooking);


    }

    const onCellEditComplete = (e) => {
        let { rowData, newValue, field, originalEvent: event } = e;
        switch (field) {
            default:
                if (newValue.trim().length > 0) rowData[field] = newValue;
                else event.preventDefault();
                break;
        }
        return
    };


    const blockuiSpinning = (
        <React.Fragment>
            <ProgressSpinner />
        </React.Fragment>
    );

    return (
        <>
            <BlockUI blocked={blockedDataTable} template={blockuiSpinning}>
                <Toast ref={toast} />
                <div className="card p-fluid">
                    <div className="formgrid grid">
                        <div className="field col-12 ">
                            <h5>Booking</h5>
                            {/* RF-B10: sube y PREVISUALIZA; no guarda nada hasta que el usuario revisa */}
                            <FileUpload ref={fileUploadRef} name="demo[]" customUpload uploadHandler={onPreviewUpload} accept=".csv, .xlsx" maxFileSize={1000000}
                                chooseLabel="Elegir archivo" uploadLabel="Subir y previsualizar" cancelLabel="Quitar"
                                emptyTemplate={<p className="m-0">Elegí el archivo de Bookings y tocá “Subir y previsualizar” (se valida antes de procesar)</p>} />
                        </div>
                        <div className="field col-12">
                            <h5>Importar ATA BNP</h5>
                            {/* Archivo con 3 columnas: BOOKING, FECHA (yyyy/MM/dd) y HORA (HH:mm:ss).
                                Se combinan en la ATA BNP. Se valida antes de aplicar; re-cargable (upsert). */}
                            <FileUpload ref={ataUploadRef} name="ata[]" customUpload uploadHandler={onAtaPreviewUpload} accept=".xlsx" maxFileSize={1000000}
                                chooseLabel="Elegir archivo" uploadLabel="Subir y previsualizar" cancelLabel="Quitar"
                                emptyTemplate={<p className="m-0">Archivo con columnas <b>BOOKING</b>, <b>FECHA</b> (<b>yyyy/MM/dd</b>) y <b>HORA</b> (<b>HH:mm:ss</b>). Se valida antes de aplicar.</p>} />
                        </div>
                    </div>
                </div>

                <div className="card">
                    <h5>Filtros</h5>
                    <div className="grid p-fluid mt-3">
                        <div className="field col-12 md:col-3">
                            <span className="p-float-label">
                                <InputNumber inputId="anio" useGrouping={false} value={anio} onValueChange={(e) => setAnio(e.value)} min={1992} max={2050} />
                                <label htmlFor="anio">Año</label>
                            </span>
                        </div>

                        <div className="field col-12 md:col-2">
                            <span className="p-float-label">
                                <Dropdown value={mes} onChange={(e) => setMes(e.value)} options={meses} optionLabel="name" placeholder="Selecciona un mes" showClear />
                            </span>
                        </div>

                        <div className="field col-12 md:col-3">
                            <span className="p-float-label">
                                <InputNumber inputId="semana" useGrouping={false} value={semana} onValueChange={(e) => onChangeSemana(e.value)} min={-1} max={53} />
                                <label htmlFor="semana">Semana</label>
                            </span>
                        </div>

                        <div className="field col-12 md:col-3">
                            <span className="p-float-label">
                                <Dropdown value={dia} onChange={(e) => setDia(e.value)} options={dias} optionLabel="name" placeholder="Selecciona un día" showClear />
                            </span>
                        </div>

                        <div className="field col-12 md:col-3">
                            <span className="p-float-label">
                                <Dropdown value={estado} onChange={(e) => setEstado(e.value)} options={estados} optionLabel="name" placeholder="Selecciona un Estado" showClear />
                            </span>
                        </div>
                        <div className="field col-12 md:col-3">
                            <span className="p-float-label">
                                <InputText inputId="booking" type="text" style={{ opacity: 1 }} optionLabel="nbookingame"  name="booking" id="booking" value={booking} onChange={(e) => setBooking(e.target.value)} />
                                <label htmlFor="booking">Booking</label>
                            </span>
                        </div>

                        <div className="field col-12 md:col-1">
                            <span className="p-float-label">
                                <Button icon="pi pi-search" severity="success" aria-label="Search" onClick={buscar} />
                                <Button icon="pi pi-save" severity="success" aria-label="Guardar" onClick={guardar} />
                            </span>



                        </div>

                    </div>
                </div>

                <div className="card p-fluid">
                    <div className="formgrid grid">
                        <div className="field col-12 ">
                            <h5>Lista de Bookings</h5>
                            <DataTable value={listaBooking} editMode="cell"
                                sortField="fechaIngreso" sortOrder={-1}>
                                <Column field='bookingId' header="BookingId" ></Column>
                                <Column field='codigo' header="Codigo"></Column>
                                <Column field='semana' header="Semana" editor={(options) => cellEditor(options)} onCellEditComplete={onCellEditComplete}></Column>
                                <Column field='diaSemana' header="DiaSemana" editor={(options) => cellEditor(options)} onCellEditComplete={onCellEditComplete}></Column>
                                <Column field='fecha' header="Fecha" editor={(options) => cellEditor(options)} onCellEditComplete={onCellEditComplete}></Column>
                                <Column field='fechaIngreso' header="FechaIngreso"></Column>
                                <Column field='fincaCodigo' header="Finca Codigo" editor={(options) => cellEditor(options)} onCellEditComplete={(options) => onCellEditComplete(options)}></Column>
                                <Column field='fincaCodigoFinal' header="Finca Codigo Final" editor={(options) => cellEditor(options)} onCellEditComplete={(options) => onCellEditComplete(options)}></Column>
                                <Column field='estado' header="Estado" editor={(options) => cellEditor(options)} onCellEditComplete={(options) => onCellEditComplete(options)}></Column>
                                <Column header="Acciones" body={(r) => (
                                    r.estado === 'Anulado'
                                        ? <Button label="Reactivar" icon="pi pi-undo" className="p-button-sm p-button-text p-button-success" onClick={() => abrirAccionBk(r.bookingId, 'reactivar')} />
                                        : (r.estado !== 'Utilizado'
                                            ? <Button label="Cancelar" icon="pi pi-ban" className="p-button-sm p-button-text p-button-danger" onClick={() => abrirAccionBk(r.bookingId, 'cancelar')} />
                                            : '')
                                )} ></Column>
                                <Column header="Log" body={(r) => (
                                    <Button icon="pi pi-history" className="p-button-sm p-button-text"
                                        tooltip="Ver log de cambios" onClick={() => verLogBooking(r)} />
                                )}></Column>
                                {/* ---- Campos nuevos DOLE (llegan por la carga masiva) ---- */}
                                <Column header="Barco-Viaje Nro" body={(r) => (r.barcoSigla ? r.barcoSigla + '-' : '') + (r.barcoViajeNumero || '')} ></Column>
                                <Column field='barcoNombre' header="Nombre del Barco" ></Column>
                                <Column field='distanciaKm' header="Distancia (km)" editor={(options) => cellEditor(options)} onCellEditComplete={(options) => onCellEditComplete(options)}></Column>
                                {/* La hora de Cut-Off no es del booking: se configura por Prioridad en Maestros DOLE (B6). */}
                                <Column header="Cut-Off mismo día" body={(r) => r.cutOffMismoDia === null || r.cutOffMismoDia === undefined ? '' : (r.cutOffMismoDia ? 'SÍ' : 'NO')} ></Column>
                            </DataTable>
                        </div>
                    </div>
                </div>
            </BlockUI>

            {/* ---- Cancelar / Reactivar booking ---- */}
            <Dialog header={accionBk && accionBk.tipo === 'reactivar' ? 'Reactivar booking' : 'Cancelar booking'} visible={accionBkVisible} style={{ width: '30rem' }} modal
                onHide={() => setAccionBkVisible(false)}
                footer={<Button label="Confirmar" icon="pi pi-check" onClick={confirmarAccionBk} />}>
                <div className="field" style={{ marginTop: '0.5rem' }}>
                    <label htmlFor="motivoBk">Motivo</label>
                    <InputText id="motivoBk" value={motivoBk} onChange={(e) => setMotivoBk(e.target.value)} style={{ width: '100%' }} />
                </div>
            </Dialog>

            {/* ---- Visor del log unificado (RF-LOG) ---- */}
            <Dialog header="Log de cambios del booking" visible={logVisible} style={{ width: '70vw' }} modal
                onHide={() => setLogVisible(false)}>
                <DataTable value={logFilas} size="small" paginator rows={10} emptyMessage="Sin cambios registrados">
                    <Column field="fecha" header="Fecha" style={{ minWidth: '11rem' }} />
                    <Column field="entidad" header="Entidad" style={{ minWidth: '7rem' }} />
                    <Column field="campo" header="Campo" style={{ minWidth: '9rem' }} />
                    <Column field="valorAnterior" header="Antes" style={{ minWidth: '9rem' }} />
                    <Column field="valorNuevo" header="Después" style={{ minWidth: '9rem' }} />
                    <Column field="motivo" header="Motivo" style={{ minWidth: '14rem' }} />
                    <Column header="Automático" body={(r) => r.esAutomatico ? 'Sí' : 'No'} style={{ minWidth: '6rem' }} />
                </DataTable>
            </Dialog>

            {/* ---- Previsualización y validación de la carga (RF-B10 / RF-B11) ---- */}
            <Dialog header="Previsualización de la carga" visible={previewVisible} style={{ width: '90vw' }} modal
                onHide={() => setPreviewVisible(false)}
                footer={
                    <div className="flex justify-content-between align-items-center">
                        <small>
                            {preview && <>
                                <b>{preview.filasTotal}</b> filas · <span style={{ color: '#16A34A' }}><b>{preview.filasOk}</b> válidas</span>
                                {preview.filasNovedad > 0 && <> · <span style={{ color: '#DC2626' }}><b>{preview.filasNovedad}</b> con novedad</span></>}
                            </>}
                        </small>
                        <div>
                            <Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={() => setPreviewVisible(false)} />
                            <Button label="Procesar lo válido" icon="pi pi-check" onClick={onProcesarPreview}
                                disabled={!preview || preview.filasOk === 0} />
                        </div>
                    </div>
                }>
                {preview && (
                    <>
                        <p className="mt-0">
                            Se procesan <b>solo las filas válidas</b>. Las que tienen novedad quedan <b>pendientes</b> (no se pierden)
                            para resolverlas y volver a cargar. Donde el faltante sea de un maestro, se puede <b>Crear</b> en el momento.
                        </p>
                        <DataTable value={preview.filas} size="small" paginator rows={15} scrollable scrollHeight="45vh"
                            emptyMessage="El archivo no tiene filas"
                            rowClassName={(f) => (f.novedades && f.novedades.length > 0) ? 'p-invalid' : ''}>
                            <Column field="linea" header="Fila" frozen alignFrozen="left" style={{ minWidth: '4rem' }} />
                            {columnasPreview(preview).map((k) => (
                                <Column key={k} header={CAMPO_LABEL[k] || k} style={{ minWidth: '8rem' }}
                                    body={(f) => {
                                        const v = f.valores?.[k];
                                        const conNovedad = (f.novedades || []).some((n) => n.campo === k || (k === 'ANO' && n.campo === 'ANIO'));
                                        return <span style={conNovedad ? { color: '#DC2626', fontWeight: 600 } : undefined}>{v}</span>;
                                    }} />
                            ))}
                            <Column header="Estado / novedades" body={estadoFilaTemplate} frozen alignFrozen="right"
                                style={{ minWidth: '26rem' }} />
                        </DataTable>
                    </>
                )}
            </Dialog>

            <Dialog header="Previsualización ATA BNP" visible={ataPreviewVisible} style={{ width: '70vw' }} modal
                onHide={() => setAtaPreviewVisible(false)}
                footer={
                    <div className="flex justify-content-between align-items-center">
                        <small>
                            {ataPreview && <>
                                <b>{ataPreview.filasTotal}</b> filas · <span style={{ color: '#16A34A' }}><b>{ataPreview.filasOk}</b> ok</span>
                                {ataPreview.filasError > 0 && <> · <span style={{ color: '#DC2626' }}><b>{ataPreview.filasError}</b> con error</span></>}
                            </>}
                        </small>
                        <div>
                            <Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={() => setAtaPreviewVisible(false)} />
                            <Button label="Aplicar ATA BNP" icon="pi pi-check" onClick={onProcesarAta}
                                disabled={!ataPreview || ataPreview.filasOk === 0} />
                        </div>
                    </div>
                }>
                {ataPreview && (
                    <>
                        <p className="mt-0">
                            Se aplican <b>solo las filas ok</b>. La ATA BNP va al <b>viaje lleno</b> del booking y se puede
                            <b> volver a cargar</b> para ajustar el valor.
                        </p>
                        <DataTable value={ataPreview.detalle} size="small" paginator rows={15} scrollable scrollHeight="45vh"
                            emptyMessage="El archivo no tiene filas"
                            rowClassName={(f) => (f.estado === 'ERROR') ? 'p-invalid' : ''}>
                            <Column field="linea" header="Fila" style={{ minWidth: '4rem' }} />
                            <Column field="booking" header="Booking" style={{ minWidth: '10rem' }} />
                            <Column field="ataBnp" header="ATA BNP" style={{ minWidth: '11rem' }} />
                            <Column header="Estado" style={{ minWidth: '18rem' }}
                                body={(f) => f.estado === 'OK'
                                    ? <span style={{ color: '#16A34A', fontWeight: 600 }}>OK</span>
                                    : <span style={{ color: '#DC2626', fontWeight: 600 }}>ERROR — {f.mensaje}</span>} />
                        </DataTable>
                    </>
                )}
            </Dialog>
        </>
    )
}

export default Booking